define(['jquery'], function () {
   "use strict";

   var $ = require('jquery');

   /**
    * Waits for a group of images to load
    */
   var ImageCache = function() {
      var m_iTotal = 0,
         m_iLoaded = 0,
         m_oImages = {},

         m_bLoadedAll = false,
         m_fnOnLoad,
         m_aFnOnLoad = [];
      
      function onLoad() {
         m_iLoaded++;
         
         if (m_iLoaded === m_iTotal) {
            m_bLoadedAll = true;

            $.each(m_aFnOnLoad, function(i, fnOnLoad) {
               fnOnLoad();
            });

            if (m_fnOnLoad) {
               m_fnOnLoad();
            }
         }
      }
      
      /**
       * Add an image to the cache
       * @param strPath      the path of the image
       * @param fnOnSuccess  (optional) callback when the image is loaded
       *                     there is no guarantee of order though
       * @param fnOnError    (optional) callback when there is an error
       */
      this.add = function(strPath, fnOnSuccess, fnOnError) {
         var img, oStatus = { loaded: false, img: null };

         // If the image has already been added
         if (m_oImages[strPath]) {
            img = m_oImages[strPath];
            oStatus.loaded = true;
            oStatus.img = img;

         // If the image has not been added
         } else {
            m_iTotal++;
            
            img = new Image();
            img.onSuccessCallbacks = [];
            img.onload = function() {
               $.each(img.onSuccessCallbacks, function(i, fnCallback) {
                  fnCallback();
               });

               oStatus.loaded = true;
               oStatus.img = img;

               img.loaded = true;
               onLoad();
            };

            img.onErrorCallbacks = [];
            img.onerror = function() {
               $.each(img.onErrorCallbacks, function(i, fnCallback) {
                  fnCallback();
               });

               img.loaded = false;
               onLoad();
            };

            m_oImages[strPath] = img;
         }

         if (fnOnSuccess) {
            img.onSuccessCallbacks.push(fnOnSuccess);
         }

         if (fnOnError) {
            img.onErrorCallbacks.push(fnOnError);
         }

         return oStatus;
      };

      this.loadedSuccessfully = function(strPath) {
         var img = m_oImages[strPath];
         return img.loaded;
      };
         
      /**
       * Start loading the images
       * @param fnOnLoad  callback for when all the images are loaded
       */
      this.load = function(fnOnLoad) {
         m_fnOnLoad = fnOnLoad;
         
         $.each(m_oImages, function(strPath, img) {
            img.src = strPath;
         });
      };

      this.onLoad = function(fnOnLoad) {
         if (m_bLoadedAll) {
            fnOnLoad();
         } else {
            m_aFnOnLoad.push(fnOnLoad);
         }
      };
   };

   return ImageCache;
});
